/* global CludoSearch */

import { debounce } from "../utils/debounce";
import { ESCAPE_KEYS } from "../utils/keys.js";
import {
  handleToggleArrowKeys,
  handleMenuArrowKeys,
} from "../utils/menuKeyNav.js";

export function initSearch(input) {
  if (!input) return;

  let dropdown = null;
  let suggestionButtons = [];

  function clearDropdown() {
    if (dropdown) {
      dropdown.remove();
      dropdown = null;
      suggestionButtons = [];
    }
  }

  function renderSuggestions(suggestions) {
    clearDropdown();
    if (!suggestions.length) return;

    dropdown = document.createElement("ul");
    dropdown.className = "search-suggestions";
    dropdown.setAttribute("role", "listbox");

    suggestions.forEach((suggestion) => {
      const li = document.createElement("li");
      li.setAttribute("role", "option");

      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = suggestion;
      btn.addEventListener("click", () => {
        input.value = suggestion;
        clearDropdown();
        input.form?.requestSubmit();
      });

      li.appendChild(btn);
      dropdown.appendChild(li);
    });

    input.parentNode.appendChild(dropdown);
    suggestionButtons = [...dropdown.querySelectorAll("button")];

    dropdown.addEventListener("keydown", (e) => {
      if (ESCAPE_KEYS.includes(e.key)) {
        clearDropdown();
        input.focus();
        return;
      }

      handleMenuArrowKeys(e, { toggle: input, items: suggestionButtons });
    });
  }

  const fetchSuggestions = debounce((term) => {
    const params = new URLSearchParams({
      action: "cludo_suggest",
      nonce: CludoSearch.nonce,
      q: term,
    });

    fetch(`${CludoSearch.ajaxUrl}?${params}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) renderSuggestions(data.data);
      })
      .catch(() => clearDropdown());
  }, 250);

  input.addEventListener("input", function () {
    const term = this.value.trim();

    if (term.length < 2) {
      clearDropdown();
      return;
    }

    fetchSuggestions(term);
  });

  input.addEventListener("keydown", (e) => {
    if (ESCAPE_KEYS.includes(e.key)) {
      clearDropdown();
      return;
    }

    handleToggleArrowKeys(e, {
      items: suggestionButtons,
      open: (target) => target.focus(),
    });
  });

  document.addEventListener("click", (e) => {
    if (!input.contains(e.target)) clearDropdown();
  });
}
